/**
 * Cores de voto. Devem espelhar os tokens em styles/global.css (@theme --color-vote-*);
 * os valores hexadecimais são necessários fora do CSS (SVG inline, three.js).
 */
export const CORES_VOTO = {
  Sim: '#2dd4bf',
  Nao: '#fb7185',
  Abstencao: '#f59e0b',
  Obstrucao: '#a78bfa',
  Presidente: '#9ca3af',
  PresenteSemVoto: '#9ca3af',
  Ausente: '#4b5563',
  Licenca: '#374151',
  Missao: '#374151',
  Outro: '#6b7280',
} as const

export type VotoValor = keyof typeof CORES_VOTO

export const ROTULOS_VOTO: Record<VotoValor, string> = {
  Sim: 'Sim',
  Nao: 'Não',
  Abstencao: 'Abstenção',
  Obstrucao: 'Obstrução',
  Presidente: 'Presidente (não vota)',
  PresenteSemVoto: 'Presente sem voto',
  Ausente: 'Ausente',
  Licenca: 'Licença',
  Missao: 'Missão oficial',
  Outro: 'Outro',
}

/** Ordem canônica para legendas e barras. */
export const ORDEM_VOTO: VotoValor[] = [
  'Sim',
  'Nao',
  'Abstencao',
  'Obstrucao',
  'Presidente',
  'PresenteSemVoto',
  'Ausente',
  'Licenca',
  'Missao',
  'Outro',
]

export function corDoVoto(valor: string | null | undefined): string {
  if (valor && valor in CORES_VOTO) {
    return CORES_VOTO[valor as VotoValor]
  }
  return CORES_VOTO.Outro
}

export function rotuloDoVoto(valor: string | null | undefined): string {
  if (valor && valor in ROTULOS_VOTO) {
    return ROTULOS_VOTO[valor as VotoValor]
  }
  return valor ?? 'Sem registro'
}

export const CORES_ORIENTACAO: Record<string, string> = {
  Sim: CORES_VOTO.Sim,
  Nao: CORES_VOTO.Nao,
  Abstencao: CORES_VOTO.Abstencao,
  Obstrucao: CORES_VOTO.Obstrucao,
  Liberado: '#e5e7eb',
  NaoInformada: '#4b5563',
}

export const ROTULOS_ORIENTACAO: Record<string, string> = {
  Sim: 'Sim',
  Nao: 'Não',
  Abstencao: 'Abstenção',
  Obstrucao: 'Obstrução',
  Liberado: 'Liberado',
  NaoInformada: 'Não informada',
}

export function corDaOrientacao(valor: string | null | undefined): string {
  return (valor && CORES_ORIENTACAO[valor]) || CORES_ORIENTACAO.NaoInformada
}

export function rotuloDaOrientacao(valor: string | null | undefined): string {
  return (valor && ROTULOS_ORIENTACAO[valor]) || 'Não informada'
}
